<template>
  <button
    :class="{ 'btn-selected': selected }"
    @click="dispatchButtonClick(button)"
    v-html="$sanitizeHtml(button.label)"
  />
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    props: {
      button: {
        type: Object,
        required: true
      },
      multiSelect: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        selected: false
      }
    },
    methods: {
      ...mapActions(['sendMessage']),
      dispatchButtonClick(button) {
        if (this.multiSelect) {
          this.selected = !this.selected

          const payload = {
            button: this.button,
            type: this.selected ? 'selected' : 'deselected'
          }

          this.$emit('multiSelected', payload)
        } else {
          this.sendMessage({
            comment: button.label,
            extendedData: { client: { buttons: [button] } }
          })
        }
      }
    }
  }
</script>

<style>
  .selected-button {
    opacity: 0.5;
  }
</style>
